import {effect, Injectable, signal, WritableSignal} from '@angular/core';
import {CartItem} from "src/app/interfaces/cart-item";
import {HttpClient} from "@angular/common/http";
import {environment} from "src/environments/environment";
import {tap} from "rxjs";
import { AuthService } from '../../Auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  cart_cache_size: number = 5;
  cart_cache: WritableSignal<CartItem[]> = signal([]);
  cart_items: WritableSignal<CartItem[]> = signal([]);
  loading: WritableSignal<boolean> = signal(false);
  api :string = ''
  constructor(private http: HttpClient,
              private auth: AuthService
  ) {
    this.api = `${environment.api}/customer/cart`;
    effect(() => localStorage.setItem('cart_cache', JSON.stringify(this.cart_cache())));
    effect(() => auth.isAuthenticated() && this.hydrate());
  }
  hydrate(){
    this.cart_cache.set(JSON.parse(localStorage.getItem('cart_cache')??'[]'));
    this.update();
  }
  public update(){
    this.loading.set(true);
    this.http
        .get<CartItem[]>(`${this.api}`)
        .subscribe({
          next: value => this.cart_items.set(value),
          complete: () =>  this.loading.set(false)
        });
  }
  add(payload: any) {
    return  this.apiAdd(payload)
                .pipe( tap(()=> this.update() ) );
  }
  remove(item: CartItem){
    return this.http.delete(`${this.api}/${item.uuid}`,{ observe: "response" })
               .pipe(tap( () => this.cart_items.update(value => [...value.filter(el=> el!=item)]) ));
  }
  removeAll(){
    return this.http.delete(`${this.api}/delete`,{ observe: "response" })
               .pipe(tap( () => this.update() ));
  }
  clear(){
    this.cart_items.set([]);
  }
  addToCache(item: CartItem){
    item.uuid = Math.random().toString(16).slice(2);
    //REMOVE LAST ELEMENT IF EXCEEDS SIZE
    if(this.cart_cache().length >= this.cart_cache_size){
      this.cart_cache.update(value => { value.pop(); return [...value] });
    }
    this.cart_cache.update(value => [...value,item]);
    return item.uuid;
  }
  getCached(id: string){
    return this.cart_cache().find(el=> el.uuid == id );
  }
  removeCached(id: string){
    return this.cart_cache.update(el=> [...el.filter(i=> i.uuid != id )]);
  }
  isLoading(){
    return this.loading();
  }
  getCart(){
    return this.cart_items;
  }
  getCartItems(){
    return this.cart_items();
  }
  getSize(){
    return this.cart_items().length;
  }
  apiAdd(payload: any) {
    return this.http.post(`${this.api}`, payload, {observe: "response" });
  }
}
